(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-age-verifcation"] && !Shopify.designMode) return;
  try {
     
  if (Shopify.designMode) return

  function createCookie (name, value, days) {
    let date, expires
    if (days) {
      date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    } else {
      expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  function getCookie(name) {
    let cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
      let [cookieName, cookieValue] = cookie.split('=');
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  }

  const dialog = document.querySelector('#ks-age-verification-dialog')

  if (window.location.href.includes('ks-age-verification')) {
    dialog.showModal()
  }

  if (!getCookie('ks-age-verification')) {
    dialog.showModal()
  }

  dialog.querySelectorAll('.ks-age-verification-dialog-date input').forEach(input => {
    input.addEventListener('input', (e) => {
      dialog.querySelector('button[data-submit]').disabled = true

      const year = dialog.querySelector('#ks-age-verification-dialog-date-year').value
      const month = dialog.querySelector('#ks-age-verification-dialog-date-month').value
      const day = dialog.querySelector('#ks-age-verification-dialog-date-day').value

      if (year.length == 4 && (month.length == 1 || month.length == 2) && (day.length == 1 || day.length == 2)) {
        const userDate = new Date(`${year}-${month}-${day}`)
        
        if (userDate) {
          const userTimestamp = Math.round(userDate.getTime() / 1000)
          const minAge = Number(dialog.dataset.minAge)
          const minTimesamp = Math.round(new Date().getTime() / 1000) - (minAge * 3.154e+7)

          if (userTimestamp < minTimesamp) {
            dialog.querySelector('button[data-submit]').disabled = false
          }
        }
      }
    })
  })

  dialog.querySelectorAll('.ks-age-verification-dialog-year input').forEach(input => {
    input.addEventListener('input', (e) => {
      dialog.querySelector('button[data-submit]').disabled = true

      const year = dialog.querySelector('#ks-age-verification-dialog-year-year').value

      if (year.length == 4) {
        const month = new Date().getMonth() + 1
        const day = new Date().getDate()

        const userDate = new Date(`${year}-${month}-${day}`)
        
        if (userDate) {
          const userTimestamp = Math.round(userDate.getTime() / 1000)
          const minAge = Number(dialog.dataset.minAge)
          const minTimesamp = Math.round(new Date().getTime() / 1000) - (minAge * 3.154e+7)

          if (userTimestamp < minTimesamp) {
            dialog.querySelector('button[data-submit]').disabled = false
          }
        }
      }
    })
  })

  dialog.querySelector('button[data-submit]').addEventListener('click', () => {
    createCookie('ks-age-verification', true, Number(dialog.dataset.configDaysToWait))
    dialog.close()
  })

  if (!window.Shopify.theme.schema_name.includes('Dawn')) {
    dialog.querySelectorAll('.field__label').forEach(elem => {
      elem.style.display = 'none'
    })
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-countdown-sale"] && !Shopify.designMode) return;
  try {
    
  class KsCountdown extends HTMLElement {
    constructor () {
      super()

      if (!this.dataset.time.length) {
        this.innerHTML = 'Datetime is missing!'
      }

      let countDownDate = Number(this.dataset.time) * 1000

      if (window.location.href.includes('ks-')) {
        countDownDate = Date.now() + 1.728e+8
      }

      const x = setInterval(() => {
        const now = new Date().getTime()
        const distance = countDownDate - now

        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        const sec = Math.floor((distance % (1000 * 60)) / 1000)

        if (days > 0) {
          this.querySelector('[data-days]').innerHTML = `${days} <em>${this.dataset.textDays}</em>`
        } else {
          this.querySelector('[data-days]')?.remove()
        }
        if (hours > 0) {
          this.querySelector('[data-hours]').innerHTML = `${hours} <em>${this.dataset.textHours}</em>`
        } else {
          this.querySelector('[data-hours]')?.remove()
        }
        this.querySelector('[data-min]').innerHTML = `${min} <em>${this.dataset.textMin}</em>`
        this.querySelector('[data-sec]').innerHTML = `${sec} <em>${this.dataset.textSec}</em>`

        this.setAttribute('data-init', '')

        if (distance < 0) {
          clearInterval(x)
          this.innerHTML = this.dataset.textExpired
        }
      }, 1000)
    }
  }
  customElements.define('ks-countdown', KsCountdown)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-fancy-slideshow"] && !Shopify.designMode) return;
  try {
    
class KsFancySlideshow extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.myInterval = setInterval(() => {
      this.init()
    }, 100);

    document.addEventListener('shopify:section:load', () => {
      if (event.target.querySelector('.ks-fancy-slideshow')) {
        this.init()
      }
    })
  }

  init () {    
    if (!window.Swiper) return

    const sliderElem = this.querySelector('.swiper')

    const navigation = {
      enabled: sliderElem.dataset.swiperNavigation === 'true',
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next' 
    }
  
    const pagination = {
      enabled: sliderElem.dataset.swiperPagination === 'bullets' || sliderElem.dataset.swiperPagination === 'fraction',
      el: '.swiper-pagination',
      type: sliderElem.dataset.swiperPagination,
      dynamicBullets: false,
      dynamicMainBullets: 2,
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
      }
    }

    const effect = sliderElem.dataset.swiperEffect
  
    const scrollbar = {
      enabled: sliderElem.dataset.swiperPagination === 'scrollbar',
      el: sliderElem.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  
    const speed = Number(sliderElem.dataset.swiperSpeed || 300)
  
    const autoplay = sliderElem.dataset.swiperAutoplay === '0'
      ? undefined
      : { delay: Number(sliderElem.dataset.swiperAutoplay) * 1000 }

    const creativeEffect = {
      prev: { translate: [0, 0, -400],},
      next: { translate: ['100%', 0, 0]},
    }

    console.log(sliderElem.dataset.swiperSpacing)

    const breakpoints = {
      0: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.4 : 1,
        spaceBetween: Math.round(Number(sliderElem.dataset.swiperSpacing) * .75)
      },
      750: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.3 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      },
      990: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.2 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      }
    }

    this.slider = new window.Swiper(sliderElem, {
      navigation,
      pagination,
      scrollbar,
      effect,
      speed,
      autoplay,
      creativeEffect,
      breakpoints,
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      fadeEffect: { crossFade: true },
      mousewheel: { enabled: true, forceToAxis: true },
      on: {
      }
    })

    clearInterval(this.myInterval)
  }
}
customElements.define('ks-fancy-slideshow', KsFancySlideshow)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-general-marquee"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.ks-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-general-parallax-image"] && !Shopify.designMode) return;
  try {
     
  class KsParallaxImage extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScript()

      setTimeout(() => {
        const instance = new simpleParallax(this.querySelectorAll('.parallax-img-init'),  {
          orientation: this.dataset.parallaxOrientation,
          scale: Number(this.dataset.parallaxScale)
        }) 
      }, 250)
    } 

    async injectVendorScript () {
      if (!window.Backpax) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/simple-parallax-js@5.6.2/dist/simpleParallax.min.js')
        script.setAttribute('integrity', 'sha256-GBIPMHSjsTxzIyJuhuk7wWz8z2oKeev8qW/c3IgOeVQ=')
        script.setAttribute('crossorigin', 'anonymous')
        document.head.appendChild(script) 
      }
    }
  }
  customElements.define('ks-parallax-image', KsParallaxImage)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-matrix-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".ks-matrix-grid [data-viewport-entered]").forEach((el) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.dataset.viewportEntered = "true";
            observer.unobserve(entry.target);

            if (entry.target.dataset.videoAutoplay === "true") {
              const video = entry.target.querySelector("video");
              if (video) {
                video.muted = true;
                video.play();
              }
            }
          }
        });
      },
      {
        rootMargin: `0px 0px -100px 0px`,
      },
    );

  observer.observe(el);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-newsletter-popup"] && !Shopify.designMode) return;
  try {
     
  if (Shopify.designMode) return
 
  // Create cookie function
  function createCookie (name, value, days) {
    let date, expires
    if (days) {
      date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    } else {
      expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  const dialog = document.querySelector('#ks-newsletter-dialog')

  // Close dialog if clicked outside
  dialog.addEventListener('click', (event) => {
    const withinBoundaries = event.composedPath().includes(dialog.querySelector('.ks-dialog-inner'))

    if (!withinBoundaries) {
      dialog.close() 
    }
  })

  // Close button
  dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
    event.preventDefault()
    dialog.close()
  })

  // Show the dialog if url contains (www.mystore.com/?ks-newsletter-popup)
  if (window.location.href.includes('ks-newsletter-popup')) {
    dialog.showModal() 
    return
  }

  // Do not show the dialog if the cookie is still present (config from settings)
  if (document.cookie.indexOf('ks-newsletter-popup') > -1) {
    return
  }

  (async () => {
    // Show the dialog on page load after some time has passed (config from settings)
    await new Promise(resolve => setTimeout(resolve, Number(dialog.dataset.configDelay) * 1000))

    // Create a cookie so that we don't show the dialog for some time (config from settings)
    createCookie('ks-newsletter-popup', true, Number(dialog.dataset.configDaysToWait))

    dialog.showModal()
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-quantity-breaks"] && !Shopify.designMode) return;
  try {
    
  const injectQtyBreaks = () => {
    const wrapper = document.querySelector('#ks-qty-breaks-hidden')

    const productInfo = document.querySelector('product-info')
    const productFormQty = productInfo.querySelector('.product-form__quantity')
    const atcButton = productInfo.querySelector('button[name="add"]')
    const variantData =  JSON.parse(document.querySelector('#ks-qty-breaks [type="application/json"]').textContent)
    // console.log(variantData)

    productInfo.querySelector('#ks-qty-breaks')?.remove()
    
    document.querySelector(wrapper.dataset.injectElement).insertAdjacentHTML(wrapper.dataset.injectElementPosition, `
      ${wrapper.innerHTML}
    `)

    document.querySelectorAll('#ks-qty-breaks input[name="ks-qty-breaks"]').forEach(input => { 
      input.addEventListener('change', () => {

        if (wrapper.dataset.btnAnimate.length) {
          setTimeout(() => {
            productInfo.querySelector('button[name="add"]').classList.add('animate__animated', wrapper.dataset.btnAnimate)
          }, 250)

          setTimeout(() => {
            productInfo.querySelector('button[name="add"]').classList.remove('animate__animated', wrapper.dataset.btnAnimate)
          }, 1500)
        }
      })
    })

    document.querySelectorAll('#ks-qty-breaks .ks-qty-breaks-variant-option select').forEach(elem => {
      elem.addEventListener('change', () => {

        let totalPrice = 0
        const discount = Number(elem.closest('.ks-qty-breaks-list-item').querySelector('input[name="ks-qty-breaks"]').dataset.discount)
        console.log(discount)

        document.querySelectorAll('#ks-qty-breaks [name="ks-qty-breaks"]:checked + label .ks-qty-breaks-variant').forEach(elem => {
          const selectedOptions = []

          elem.querySelectorAll('select').forEach(select => {
            selectedOptions.push(select.value)
          })

          const selectedVariant = variantData.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
          )

          totalPrice += selectedVariant.price
        })
        

        elem.closest('.ks-qty-breaks-list-item').querySelector('.ks-qty-breaks-label-total').innerHTML = `
          ${formatMoney(totalPrice * (100 - discount) / 100).replace('.00', '')} <s>${formatMoney(totalPrice).replace('.00', '')}</s>
        `

      })
    })

    atcButton.classList.remove('button--secondary')

    atcButton.addEventListener('click', async (event) => {
      event.preventDefault()
      
      atcButton.setAttribute('aria-disabled', true)
      atcButton.classList.add('loading')
      atcButton.querySelector('.loading__spinner').classList.remove('hidden')

      const items = []

      document.querySelectorAll('#ks-qty-breaks [name="ks-qty-breaks"]:checked + label .ks-qty-breaks-variant').forEach(elem => {
        const selectedOptions = []

        elem.querySelectorAll('select').forEach(select => {
          selectedOptions.push(select.value)
        })

        const selectedVariant = variantData.find(variant =>
          JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
        )
        items.unshift({
          id: selectedVariant.id,
          quantity: 1
        })
      })

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      let sections = cart.getSectionsToRender().map((section) => section.id)

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections })
      })
      const responseData = await response.json()

      cart.renderContents(responseData)
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')

      atcButton.setAttribute('aria-disabled', false)
      atcButton.classList.remove('loading')
      atcButton.querySelector('.loading__spinner').classList.add('hidden')
    })

    const moneyFormat = document.querySelector('#ks-qty-breaks').dataset.moneyFormat

    function formatMoney (cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }

      let value = ''
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

      function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
      }

      function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        const cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
      }

      switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      }

      return moneyFormat.replace(placeholderRegex, value)
    }
  }
  injectQtyBreaks()

  const listenVariantChanges = () => {
    document.querySelectorAll('variant-selects [name]').forEach(elem => {
      elem.addEventListener('change', () => { 
        document.querySelector('#ks-qty-breaks').style.opacity = '.2'

        setTimeout(async () => { 
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#ks-qty-breaks-hidden')
            .replaceWith(newDocument.querySelector('#ks-qty-breaks-hidden'))
          
          injectQtyBreaks()
        }, 500)
      })
    })
  }
  listenVariantChanges()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
    this.autoplayPausedByUser = false

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
      this.slider = slider

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
        this.playActiveSlideVideo()
      })

      this.playActiveSlideVideo()
    }, 500)

    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.autoplay = false
      video.removeAttribute('autoplay')
      video.pause()

      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })

      video.addEventListener('play', () => {
        this.pauseAllVideos(video)

        const card = video.closest('.ks-shoppable-videos-card')
        if (card) {
          card.setAttribute('data-is-playing', 'true')
        }
      })
    })

    this.querySelectorAll('video[data-autoplay="true"]').forEach((video) => {
      video.muted = true
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.pauseAllVideos()

    if (this.autoplayPausedByUser) {
      this.autoplayPausedByUser = false
      this.resumeSliderAutoplay()
    }
  }

  pauseSliderAutoplayByUser () {
    if (this.dataset.sliderAutoplay === '0') return
    if (!this.slider?.autoplay) return

    this.autoplayPausedByUser = true
    this.slider.autoplay.stop()
  }

  resumeSliderAutoplay () {
    if (this.dataset.sliderAutoplay === '0') return
    if (!this.slider?.autoplay) return

    this.slider.autoplay.start()
  }

  pauseAllVideos (exceptVideo = null) {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      const video = elem.querySelector('video')

      if (exceptVideo && video === exceptVideo) {
        return
      }

      elem.setAttribute('data-is-playing', 'false')
      video?.pause()
    })
  }

  playActiveSlideVideo () {
    const activeSlide = this.querySelector('.swiper-slide-active')
    const activeVideo = activeSlide?.querySelector('video[data-autoplay="true"]')

    this.pauseAllVideos(activeVideo)

    if (!activeVideo) return

    const card = activeVideo.closest('.ks-shoppable-videos-card')
    if (card) {
      card.setAttribute('data-is-playing', 'true')
    }

    activeVideo.muted = true
    activeVideo.play().catch(() => {})
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.pauseAllVideos(video)
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
      this.pauseSliderAutoplayByUser()
    }
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-spinning-wheel"] && !Shopify.designMode) return;
  try {
    
  class KsSpinningWheel extends HTMLElement {
    constructor() {
      super();

      this.dialog = this.closest('dialog');
      this.wheel = null;
      this.initWheel();
      this.handleDialogOpen();
      this.handleDialogClose();
      this.handleFormSubmit();
      this.handleDiscountCodesClick();
    }

    initWheel() {
      const vendorScript = document.querySelector('script[src*="spin-wheel"]');
      const settings = JSON.parse(this.querySelector('script[data-blocks]').textContent).settings;
      const blocks = JSON.parse(this.querySelector('script[data-blocks]').textContent).blocks;

      vendorScript.onload = async () => {
        if (Shopify.designMode) {
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }

        this.wheel = new spinWheel.Wheel(this.querySelector('.ks-snipping-wheel-container'), {
          borderColor: settings.border_color,
          borderWidth: settings.border_width,
          isInteractive: false,
          lineWidth: settings.line_width,
          lineColor: settings.line_color,
          itemLabelFontSizeMax: 16,
          itemLabelRadius: 0.875,
          itemLabelRadiusMax: -0.25,
          radius: 1,
          rotationResistance: 0,
          items: blocks.map((block) => ({
            label: block.label,
            backgroundColor: block.bg_color,
            labelColor: block.label_color,
          })),
          onRest: (event) => {
            console.log(event);
            this.handleWinningBlock(event.currentIndex);
          },
          onSpin: (event) => {
            console.log(event);
          },
        });

        if (this.dataset.wheelSpintAtStart === 'true') {
          this.wheel.spin(5);
        }
      };
    }

    async handleDialogOpen() {
      if (Shopify.designMode) return;

      if (window.location.href.includes('ks-spinning-wheel')) {
        this.dialog.showModal();
      }

      if (this.getCookie('ks-spinning-wheel')) {
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, Number(this.dialog.dataset.configDelay) * 1000));
      this.createCookie('ks-spinning-wheel', true, Number(this.dialog.dataset.configDaysToWait));

      this.dialog.showModal();
    }

    handleDialogClose() {
      this.dialog.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(this.dialog.querySelector('.ks-dialog-inner'));
        if (!withinBoundaries) {
          this.dialog.close();
        }
      });

      this.dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.dialog.close();
      });
    }

    createCookie(name, value, days) {
      let date, expires;
      if (days) {
        date = new Date();
        date.setDate(date.getDate() + days);
        expires = '; expires=' + date.toUTCString();
      } else {
        expires = '';
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }

    getCookie(name) {
      let cookies = document.cookie.split('; ');
      for (let cookie of cookies) {
        let [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
      return null;
    }

    handleFormSubmit() {
      const form = this.querySelector('form');
      const button = form.querySelector('button');
      const alertWarning = this.querySelector('.ks-alert-warning');
      const alertSuccess = this.querySelector('.ks-alert-success');

      window.Shopify.captcha.protect(form, () => {
        window.hcaptcha.execute();
      });

      button.addEventListener('click', async (event) => {
        event.preventDefault();

        alertWarning.setAttribute('hidden', 'hidden');
        button.classList.add('loading');
        button.setAttribute('disabled', 'disabled');
        button.querySelector('.loading__spinner').classList.remove('hidden');

        const isTesting = window.location.href.includes('ks-');

        if (isTesting) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          this.spinWheel();
        } else {
          const formData = new FormData(form);

          const response = await fetch('/contact', {
            method: 'POST',
            body: formData,
          });

          if (response.ok) {
            this.spinWheel();
          } else {
            alertWarning.removeAttribute('hidden');
          }
        }

        button.classList.remove('loading');
        button.removeAttribute('disabled');
        button.querySelector('.loading__spinner').classList.add('hidden');
        this.querySelector('.ks-dialog-form-wrapper').style.opacity = '.2';
      });
    }

    spinWheel() {
      if (this.querySelector('audio')) {
        this.querySelector('audio').play();
      }
      const randomIndex = Math.floor(Math.random() * this.wheel.items.length);
      this.wheel.spinToItem(randomIndex, 4000, false, 4, 1, null);
    }

    handleDiscountCodesClick() {
      this.querySelectorAll('button[data-ks-discount-code]').forEach((button) => {
        button.addEventListener('click', (event) => {
          const discountCode = button.textContent;
          navigator.clipboard.writeText(discountCode);
          button.textContent = button.dataset.textCopied;

          setTimeout(() => {
            button.textContent = discountCode;
          }, 2000);
        });
      });
    }

    handleWinningBlock(index) {
      this.querySelector('.ks-dialog-form-wrapper').setAttribute('hidden', 'hidden');
      this.querySelectorAll('.ks-dialog-winning-block-item').forEach((block, i) => {
        if (i === index) {
          block.removeAttribute('hidden');

          if (block.dataset.confetti === 'true') {
            const jsConfetti = new JSConfetti({
              canvas: this.querySelector('canvas[data-ks-confetti]'),
            });
            jsConfetti.addConfetti();
          }
        }
      });
      if (this.querySelector('audio')) {
        this.querySelector('audio').pause();
      }
    }
  }
  customElements.define('ks-spinning-wheel', KsSpinningWheel);

  } catch(e) { console.error(e); }
})();
})();
